import { OptionTypeBase } from "@advapacs/common";
import { useEffect, useState } from "react";
import axios from "axios";

const useRegionDropdown = (): Array<OptionTypeBase> => {
  const [regionOptions, setRegionOption] =
    useState<Array<{ code: string; name: string } | undefined>>(undefined);
  useEffect(() => {
    const getRegions = async () => {
      const data = await axios.get("/regions");
      setRegionOption(
        data.data.content.map((x: { code: string; name: string }) => {
          return {
            label: x.name,
            value: x.code,
          };
        })
      );
    };
    if (!regionOptions) getRegions();
  }, [regionOptions]);

  return regionOptions;
};

export default useRegionDropdown;
